import palette from '../palette';

const MuiDivider = {
  styleOverrides: {
    root: {
      backgroundColor: palette.graphic.light,
      borderColor: 'transparent',
    },
  },
};

export default MuiDivider;
